/**
 * Created by Roman on 2014-10-15.
 */


angular
    .module("flipto.core.user")
    .config(['$filterProvider', function ($filterProvider) {

        $filterProvider.register('fullName', [function () {

            function getFirstName(source) {
                return source.first || source.FirstName;
            }

            function getLastName(source) {
                return source.last || source.LastName;
            }

            function formatName(source, isInitialOnly) {
                var name = getFirstName(source);
                if (getLastName(source)) name += ' ' + (isInitialOnly ? (getLastName(source).substring(0, 1) + ".") : getLastName(source));
                return name;
            }

            // Fallback display when no first/last name is present, so records
            // identified only by other PII still render a meaningful label.
            function fallbackName(source) {
                if (source.email || source.Email) return source.email || source.Email;
                if (source.crsNumber || source.crs_number) return 'CRS# ' + (source.crsNumber || source.crs_number);
                if (source.pmsNumber || source.pms_number) return 'PMS# ' + (source.pmsNumber || source.pms_number);
                return '';
            }

            return function (source, isInitialOnly) {
                if (!source) return '';
                if (!getFirstName(source) && !getLastName(source)) return fallbackName(source);
                if (angular.isDefined(isInitialOnly) === false) isInitialOnly = false;
                return formatName(source, isInitialOnly);
            };
        }]);
    }]);